export default {
  computed: {
    isMobile: function () {
      return this.$store.state.IS_MOBILE;
    },
    isTablet: function () {
      return this.$store.state.IS_TABLET;
    },
    isDesktop: function () {
      return !this.$store.state.IS_MOBILE && !this.$store.state.IS_TABLET;
    },
  }
}
